<template>
  <div class="cf-review space-y-6" data-cy="cf-review-view">
    <div>
      <h2 class="text-xl font-semibold text-gray-900">
        {{ form.name || "Untitled form" }}
      </h2>
      <p v-if="form.description" class="mt-1 text-sm text-gray-500">
        {{ form.description }}
      </p>
    </div>

    <p v-if="!form.sections.length" class="text-sm text-gray-400">
      This form has no sections yet.
    </p>

    <div v-for="section in form.sections" :key="section._key" class="space-y-3">
      <h3 class="text-sm font-semibold uppercase tracking-wide text-gray-500">
        {{ section.name || "Untitled section" }}
      </h3>
      <p v-if="section.description" class="text-sm text-gray-500">
        {{ section.description }}
      </p>
      <div class="ml-2 space-y-5 border-l-2 border-gray-200 pl-5">
        <p v-if="!section.questions.length" class="text-sm text-gray-400">
          No questions.
        </p>
        <div v-for="question in section.questions" :key="question._key">
          <div class="mb-1 flex items-center gap-2">
            <span class="text-sm font-medium text-gray-900">{{
              question.title || "Untitled question"
            }}</span>
            <span v-if="question.required" class="text-red-500" title="Required"
              >*</span
            >
            <span v-if="!question.customer_visible" class="cf-badge"
              >Internal</span
            >
          </div>
          <p v-if="question.description" class="mb-2 text-sm text-gray-500">
            {{ question.description }}
          </p>
          <CustomFormTypePreview
            :type="question.question_type"
            :options="question.options"
            :unit="question.unit"
          />
          <p
            v-if="question.photo_requirement !== 'no_photos'"
            class="mt-2 text-xs text-gray-400"
          >
            <i class="fas fa-camera mr-1"></i>
            {{
              question.photo_requirement === "required_photos"
                ? `Photo required (min ${question.photo_min_count})`
                : "Photo optional"
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { BuilderSection } from "./customFormFields";
import CustomFormTypePreview from "./CustomFormTypePreview.vue";

defineProps<{
  form: { name: string; description: string; sections: BuilderSection[] };
}>();
</script>

<style scoped>
.cf-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  background: #f3f4f6;
  padding: 0.0625rem 0.5rem;
  font-size: 0.6875rem;
  font-weight: 500;
  color: #6b7280;
}
</style>
